/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginationMetaSchema = z.object({
	currentPage: z.number(),
	lastPage: z.number(),
	perPage: z.number(),
	total: z.number(),
})

export type PaginationMetaSchema = z.infer<typeof paginationMetaSchema>
